export default __webpack_public_path__ + "static/media/prev-GNSS-Antenna-5.662b56c5.png";